module.exports = __webpack_public_path__ + "img/jimmy.2ab6961c.jpg";